import { 
    getTableData, 
    accumulatedDepreciation, 
    generalAndAdmin, 
    Average,
    CFIRR,
    getRatio,
    findClosestDate,
    growthRate,
    getTaxRate,
    getAssetLife,
    fillLeadingZerosWithFirstValue,
    getRowValue,
    EBITDA
} from "./process_morningstar.js";

// function getTaxRate(IS, selectedTax, ebitda) {
//   if (selectedTax) {
//     return n(IS['TaxProvision']);
//   }
//   return ((n(ebitda - IS['ReconciledDepreciation']) - n(IS['InterestExpense'])) * 0.28);
// }

async function getCurrentCashFlowShare(capRD, includeOtherIncome, selectedTax) {
    const incomeStatement3M = await getTableData("Income Statement 3M");
    const balanceSheet3M = await getTableData("Balance Sheet 3M");
    const ratesTable = await getTableData("Rates");
    const QuarterlyPrices = await getTableData("QuarterlyPrice");
    const earningReports3M = await getTableData("Earnings Reports 3M");
    const rates = ratesTable[0];
    const prices = QuarterlyPrices[1];


    let numOfPeriods = 0;
    let naCAPrev = 0;
    let aDepPrev = 0;
    let inflationTableValue = 0;
    let grossInvestedCapitalGrw = 0;
    let grossInvestedCapitalGrwIncl = 0;
    let plowbackRatio = 0;
    let plowbackRatioIncl = 0;
    let cfirr = 0;
    let cfirrIncl = 0;
    let cashFlowSum = 0;
    let grossMarginExcl = 0;
    let totalRevenue = 0;
    let debtAndEquivalents = 0;
    let marketCap = 0;
    let debtOverMarketCap = 0;
    let enterpriseValue = 0;
    let salvageValueArray = []; 
    let annualAssetLifeArray = [];
    let CFSharesArray = [];
    let sharesArray = [];
    let finalValues = [];
    let assetLifeArray = [];
    let depreciationArray = [];
    let cashFlowArray = [];
    let grossInvestedCapitalArray = [];
    let grossInvCapitalInclArray = [];
    let annualCapitalIncl = [];
    let annualAssetLifeArrayInclIntangible = [];
    let assetLifeArrayInclIntangible = [];
    let plowbackNumerator = [];
    let plowbackDenominator = [];
    let plowbackDenominatorIncl = [];
    let interestExpenseArray = [];
    let grossMarginExclArray = [];
    let totalRevenueArray = [];
    let ebitdaArray = [];
    let finaldate = "";
    for (let i = 0; i < incomeStatement3M.length; i++) {
        const IS = incomeStatement3M[i], BS3M = balanceSheet3M[i], ER = earningReports3M[i];
        if (!IS) continue;
        if (numOfPeriods < 5) numOfPeriods++;


        // -------- cashFlowShare -----------
        const generalAdmin = generalAndAdmin(IS, IS);

        sharesArray.push(n(BS3M['OrdinarySharesNumber']));
        const sharesRatio = getRatio(BS3M, numOfPeriods, sharesArray);

        if (sharesArray.length === 5) sharesArray.shift();

        const ebitda = (n(IS['TotalRevenue']) - n(IS['CostOfRevenue'])) 
        - n(generalAdmin) 
        - (capRD ? 0 : n(IS['ResearchAndDevelopment'])) 
        + n(IS['EarningsFromEquityInterest']) 
        + n(IS['ReconciledDepreciation'])
        + (includeOtherIncome ? (n(IS['OtherIncomeExpense']) - n(IS['SpecialIncomeCharges']) - n(IS['RestructuringAndMergernAcquisition'])) : 0)

        const userTax = getTaxRate(IS, selectedTax, IS, IS, includeOtherIncome, capRD); 

        const cashFlowShares = ((ebitda - userTax - (0.28 * n(IS['InterestExpense']))) / n(sharesRatio));

        // -------- Capital Growth -----------
        naCAPrev = n(IS['ResearchAndDevelopment']) + naCAPrev;

        const totalOtherFixedCapital = n(BS3M['Goodwill']) + 
            (n(BS3M['GoodwillAndOtherIntangibleAssets']) - 
            n(BS3M['Goodwill'])) + n(BS3M['NonCurrentDeferredAssets']) + 
            n(BS3M['TotalNonCurrentAssets']) - (n(BS3M['NetPPE']) + 
            n(BS3M['Goodwill']) + n(BS3M['NonCurrentDeferredAssets']) + 
            (n(BS3M['GoodwillAndOtherIntangibleAssets']) - n(BS3M['Goodwill'])) + 
            (n(BS3M['InvestmentsAndAdvances']) + n(BS3M['DeferredCosts']) + 
            n(BS3M['NetLoan']) + n(BS3M['DefinedPensionBenefit']) + 
            n(BS3M['FinancialAssets']))) + (n(BS3M['InvestmentsAndAdvances']) + 
            n(BS3M['DeferredCosts']) + n(BS3M['NetLoan']) + n(BS3M['DefinedPensionBenefit']) + n(BS3M['FinancialAssets']));

        const otherNonCurrentAssets = n(BS3M['TotalNonCurrentAssets']) - 
            (n(BS3M['NetPPE']) + n(BS3M['Goodwill']) + n(BS3M['NonCurrentDeferredAssets']) + 
            (n(BS3M['GoodwillAndOtherIntangibleAssets']) - n(BS3M['Goodwill'])) + 
            (n(BS3M['InvestmentsAndAdvances']) + n(BS3M['DeferredCosts']) + 
            n(BS3M['NetLoan']) + n(BS3M['DefinedPensionBenefit']) + n(BS3M['FinancialAssets'])));

        const investmentsAndAdvances = n(BS3M['InvestmentsAndAdvances']) + 
            n(BS3M['DeferredCosts']) + n(BS3M['NetLoan']) + 
            n(BS3M['DefinedPensionBenefit']) + n(BS3M['FinancialAssets']);

        const totalCurrentAssets = (n(BS3M['CurrentAssets']) - 
            ((Math.max(n(BS3M['AccountsReceivable']), n(BS3M['Receivables']))) + 
            n(BS3M['Inventory']) + n(BS3M['PrepaidAssets']) + 
            n(BS3M['CurrentDeferredTaxesAssets']) + n(BS3M['CashAndCashEquivalents']) + 
            n(BS3M['RestrictedCash']) + n(BS3M['OtherShortTermInvestments']))) + 
            n(BS3M['CashAndCashEquivalents']) + n(BS3M['RestrictedCash']) +
            n(BS3M['OtherShortTermInvestments']) + 
            (Math.max(n(BS3M['AccountsReceivable']), n(BS3M['Receivables']))) + 
            n(BS3M['Inventory']) + n(BS3M['PrepaidAssets']) + n(BS3M['CurrentDeferredTaxesAssets']);

        const otherMiscLiabilities = n(BS3M['CurrentLiabilities']) - 
            (n(BS3M['AccountsPayable']) + n(BS3M['DividendsPayable']) + 
            n(BS3M['CurrentNotesPayable']) + n(BS3M['CurrentDebtAndCapitalLeaseObligation']) + 
            n(BS3M['CurrentAccruedExpenses']) + n(BS3M['CurrentDeferredLiabilities']) + 
            n(BS3M['TotalTaxPayable']) + n(BS3M['OtherCurrentLiabilities']));

        const currentLiabilities = 
            n(BS3M['AccountsPayable']) +
            n(BS3M['DividendsPayable']) +
            n(BS3M['CurrentNotesPayable']) +
            n(BS3M['CurrentAccruedExpenses']) +
            n(BS3M['CurrentDeferredLiabilities']) +
            n(BS3M['TotalTaxPayable']) +
            n(BS3M['OtherCurrentLiabilities']) +
            n(otherMiscLiabilities);

        const otherIntangibleAssets = 
            n(BS3M['GoodwillAndOtherIntangibleAssets']) - 
            n(BS3M['Goodwill'])


        const netPPE = n(BS3M['NetPPE']);
        const grossPPE = n(BS3M['GrossPPE']);
        const accumulatedDep = n(accumulatedDepreciation(BS3M, IS, aDepPrev));

        aDepPrev = accumulatedDep;

        const grossFixedAssets =
          Math.max((netPPE + accumulatedDep), grossPPE) +
          ((capRD ? naCAPrev : 0))

        depreciationArray.push(n(IS['ReconciledDepreciation']));

        assetLifeArray.push(
            grossFixedAssets +
            n(otherNonCurrentAssets) +
            n(investmentsAndAdvances) +
            n(BS3M['Inventory'])
        );

        assetLifeArrayInclIntangible.push(
          grossFixedAssets +
            n(IS['ResearchAndDevelopment']) +
            n(BS3M['Goodwill']) +
            n(otherIntangibleAssets) +
            n(otherNonCurrentAssets) +
            n(investmentsAndAdvances) +
            n(BS3M['Inventory'])
        );

        const assetLife = Math.round(Math.min(Math.max(3, n(getAssetLife(numOfPeriods, IS, assetLifeArray, depreciationArray))), 30));
        const assetLifeInclIntangibles = Math.round(Math.min(Math.max(3, n(getAssetLife(numOfPeriods, IS, assetLifeArrayInclIntangible, depreciationArray))), 30));

        annualAssetLifeArray.push(assetLife);
        annualAssetLifeArrayInclIntangible.push(assetLifeInclIntangibles);

        const averageAssetLife = Math.round(Math.max(3, Average(annualAssetLifeArray)));
        const averageAssetLifeInclIntangible = (Math.max(3, Average(annualAssetLifeArrayInclIntangible)));

        if (annualAssetLifeArray.length === 12) annualAssetLifeArray.shift();
        if (annualAssetLifeArrayInclIntangible.length === 12) annualAssetLifeArrayInclIntangible.shift();

        const yearIndex =
          Math.ceil(
            Math.min(30, averageAssetLife) *
              (1 - netPPE / (netPPE + accumulatedDep))
          ) * 365;

        const inflationAge = new Date(IS['AsOfDate']).getTime() - yearIndex * 86400 * 1000;
        const inflationDate = findClosestDate(new Date(inflationAge), rates);
        const inflationAgeDate = findClosestDate(new Date(inflationAge).getTime(), rates);

        const inflationTableAge = rates[inflationAgeDate];

        if (rates[IS['AsOfDate']] !== undefined) {
            inflationTableValue = n(rates[IS['AsOfDate']]);
        } else {
            inflationTableValue = rates[inflationDate];
        }

        grossInvestedCapitalArray.push(
          (n(totalOtherFixedCapital) - 
            n(BS3M['Goodwill']) - (n(BS3M['GoodwillAndOtherIntangibleAssets']) - 
            n(BS3M['Goodwill'])) + n(grossFixedAssets)) *
            (n(inflationTableValue) / n(rates[inflationDate])) +
            Math.max(n(totalCurrentAssets) - currentLiabilities, 0)
        );

        grossInvCapitalInclArray.push(
          (n(totalOtherFixedCapital) +
            grossFixedAssets) *
            (n(inflationTableValue) / n(inflationTableAge)) +
          Math.max(n(totalCurrentAssets) - currentLiabilities, 0)
        )

        const grossInvestedCapitalIncl =
          (n(totalOtherFixedCapital) +
            grossFixedAssets) *
            (n(inflationTableValue) / n(inflationTableAge)) +
          Math.max(n(totalCurrentAssets) - currentLiabilities, 0);

        annualCapitalIncl.push(grossInvestedCapitalIncl);


        grossInvestedCapitalGrw = growthRate(grossInvestedCapitalArray.at(-1), grossInvestedCapitalArray.at(-5));
        grossInvestedCapitalGrwIncl = growthRate(grossInvCapitalInclArray.at(-1), grossInvCapitalInclArray.at(-5));
        
        
        CFSharesArray.push(cashFlowShares);

        // --------CFIRR-------------

        const specialItems =
          n(IS['RestructuringAndMergernAcquisition']) +
          n(IS['AcquiredInProcessRnDIncome']) +
          n(IS['SpecialIncomeCharges']);

        const otherIncomeAdj =
          n(IS['OtherIncomeExpense']) -
          n(IS['SpecialIncomeCharges']) -
          n(IS['RestructuringAndMergernAcquisition']);

        const netIncome =
          (
            n(ebitda) -
            n(IS['ReconciledDepreciation']) +
            n(IS['InterestIncome']) +
            specialItems +
            otherIncomeAdj -
            n(IS['InterestExpense']) -
            n(IS['EarningsFromEquityInterest']) -
            n(IS['TaxProvision'])
          ) +
          n(IS['NetIncomeDiscontinuousOperations']) +
          n(IS['NetIncomeExtraordinary']) +
          n(IS['CumulativeEffectOfAccountingChange']) +
          n(IS['NetIncomeFromTaxLossCarryforward']) +
          n(IS['OtherOperatingExpenses']) +
          n(IS['MinorityInterests']);

        const nonOperationIncome = n(IS['InterestIncome']) + 
            n(IS['RestructuringAndMergernAcquisition']) + 
            n(IS['AcquiredInProcessRnDIncome']) + 
            n(IS['SpecialIncomeCharges']) + 
            (n(IS['OtherIncomeExpense']) - n(IS['SpecialIncomeCharges']) - n(IS['RestructuringAndMergernAcquisition']));

        const totalOtherIncome = n(IS['NetIncomeDiscontinuousOperations']) + 
            n(IS['NetIncomeExtraordinary']) + 
            n(IS['CumulativeEffectOfAccountingChange']) + 
            n(IS['NetIncomeFromTaxLossCarryforward']) + 
            n(IS['OtherOperatingExpenses']);

        const cashFlowFromOps =
          n(netIncome) -
          n(nonOperationIncome) -
          n(totalOtherIncome) +
          0.72 * n(IS['InterestExpense']) +
          n(IS['MinorityInterests']) +
          n(IS['ReconciledDepreciation']) -
          (n(userTax) - n(IS['TaxProvision']));

        const cashFlowFromOps2 =
          n(ebitda) - n(userTax) - 0.28 * n(IS['InterestExpense']);

        cashFlowArray.push(cashFlowFromOps2);

        cashFlowSum = cashFlowArray.reduce((a, b) => a + b, 0);

        const grossInvestedCapital =
          (n(totalOtherFixedCapital) -
            n(BS3M['Goodwill']) -
            (n(BS3M['GoodwillAndOtherIntangibleAssets']) - n(BS3M['Goodwill'])) +
            grossFixedAssets) *
            (n(inflationTableValue) / n(rates[inflationDate])) +
          Math.max(n(totalCurrentAssets) - currentLiabilities, 0);

        const totalCurrentLiabilities = n(BS3M['AccountsPayable']) + 
            n(BS3M['DividendsPayable']) + 
            n(BS3M['CurrentNotesPayable']) + 
            n(BS3M['CurrentDebtAndCapitalLeaseObligation']) + 
            n(BS3M['CurrentAccruedExpenses']) + 
            n(BS3M['CurrentDeferredLiabilities']) + 
            n(BS3M['TotalTaxPayable']) + 
            n(BS3M['OtherCurrentLiabilities']) + 
            (n(BS3M['CurrentLiabilities']) - 
            (n(BS3M['AccountsPayable']) + 
            n(BS3M['DividendsPayable']) + 
            n(BS3M['CurrentNotesPayable']) + 
            n(BS3M['CurrentDebtAndCapitalLeaseObligation']) + 
            n(BS3M['CurrentAccruedExpenses']) + n(BS3M['CurrentDeferredLiabilities']) + n(BS3M['TotalTaxPayable']) + n(BS3M['OtherCurrentLiabilities'])));

        const salvageValue = Math.max(
          0,
          n(totalCurrentAssets) -
            (n(totalCurrentLiabilities) - n(BS3M['CurrentDebtAndCapitalLeaseObligation']))
        );

        salvageValueArray.push(salvageValue);
        const salvageValueAvg = Average(salvageValueArray);
        

        if (grossInvestedCapitalArray.length === 5) {
            const presentValue = Average(grossInvestedCapitalArray) * -1;
            const pvIncl = Average(annualCapitalIncl) * -1;
        
            cfirr = CFIRR(assetLife, cashFlowSum, presentValue, salvageValueAvg, 0, 0.07) * 100;
            cfirrIncl = CFIRR(assetLifeInclIntangibles, cashFlowSum, pvIncl, salvageValueAvg, 0, 0.07) * 100;

            grossInvestedCapitalArray.shift();
            annualCapitalIncl.shift();
            salvageValueArray.shift();
        }

        if (cashFlowArray.length === 4) {
          cashFlowArray.shift();
          assetLifeArray.shift();
          assetLifeArrayInclIntangible.shift();
        }

        // -----------PlowBack----------------
        plowbackNumerator.push(cashFlowFromOps);
        plowbackDenominator.push(grossInvestedCapital);
        plowbackDenominatorIncl.push(grossInvestedCapitalIncl);
        interestExpenseArray.push(0.72 * n(IS['InterestExpense']));

        const cashflowPlowback = [5, 6, 7, 8].map((i) => n(plowbackNumerator.at(-i))).reduce((a, b) => a + b, 0);
        const interestExpensePlowback = [5, 6, 7, 8].map((i) => n(interestExpenseArray.at(-i))).reduce((a, b) => a + b, 0);

        plowbackRatio =
          ((cashflowPlowback - interestExpensePlowback) / plowbackDenominator.at(-5)) * 100;
        
        plowbackRatioIncl = 
          ((cashflowPlowback - interestExpensePlowback) / plowbackDenominatorIncl.at(-5)) * 100;

        //----------- $Millions -------------
        grossMarginExcl = n(IS['TotalRevenue']) - n(IS['CostOfRevenue']);
        grossMarginExclArray.push(grossMarginExcl);        

        totalRevenue = n(IS['TotalRevenue']);
        totalRevenueArray.push(totalRevenue);

        // -----------Capital Growth----------------
        debtAndEquivalents = n(BS3M['CurrentDebtAndCapitalLeaseObligation']) + 
            n(BS3M['LongTermDebt']) + n(BS3M['LongTermCapitalLeaseObligation']) + 
            n(BS3M['DerivativeProductLiabilities']) + n(BS3M['EmployeeBenefits']) + 
            n(BS3M['LongTermProvisions']) + n(BS3M['RegulatoryLiabilities']) + 
            n(BS3M['OtherNonCurrentLiabilities']) + (n(BS3M['CurrentLiabilities']) - 
            (n(BS3M['AccountsPayable']) + n(BS3M['DividendsPayable']) + 
            n(BS3M['CurrentNotesPayable']) + n(BS3M['CurrentDebtAndCapitalLeaseObligation']) + 
            n(BS3M['CurrentAccruedExpenses']) + n(BS3M['CurrentDeferredLiabilities']) + 
            n(BS3M['TotalTaxPayable']) + n(BS3M['OtherCurrentLiabilities']))) + 
            n(BS3M['MinorityInterest']) + n(BS3M['PreferredStockOfSubsidiary']) + 
            n(BS3M['PreferredSecuritiesOutsideStockEquity']) + n(BS3M['PreferredStockEquity'])

        // --- Price ---
        const rawPriceDate = new Date(IS['AsOfDate']);
        rawPriceDate.setDate(rawPriceDate.getDate() + 45);
        const priceDate = findClosestDate(rawPriceDate, prices);

        marketCap = (n(ER['BasicAverageShares'] / 1000000) * n(prices[priceDate]))

        debtOverMarketCap = ((debtAndEquivalents / (n(ER['BasicAverageShares'] / 1000000) * n(prices[priceDate]))))

        // ------------ Multiples --------------

        const nonCurrentMiscLiabilities = 
            n(BS3M['TotalNonCurrentLiabilitiesNetMinorityInterest']) - 
            (n(BS3M['LongTermDebt']) + n(BS3M['LongTermCapitalLeaseObligation']) + 
            n(BS3M['NonCurrentDeferredLiabilities']) + n(BS3M['NonCurrentAccruedExpenses']) + 
            n(BS3M['DerivativeProductLiabilities']) + n(BS3M['EmployeeBenefits']) + 
            n(BS3M['LongTermProvisions']) + n(BS3M['RegulatoryLiabilities']) + n(BS3M['OtherNonCurrentLiabilities']));

        ebitdaArray.push(ebitda);
        enterpriseValue = ((n(ER['BasicAverageShares'] / 1000000) * n(prices[priceDate])) + (n(BS3M['CurrentDebtAndCapitalLeaseObligation']) + n(BS3M['LongTermDebt']) + n(BS3M['LongTermCapitalLeaseObligation']) + n(BS3M['NonCurrentDeferredLiabilities']) + n(BS3M['NonCurrentAccruedExpenses']) +  n(BS3M['DerivativeProductLiabilities']) + n(BS3M['EmployeeBenefits']) + n(BS3M['LongTermProvisions']) + n(BS3M['RegulatoryLiabilities']) + n(BS3M['OtherNonCurrentLiabilities']) + n(nonCurrentMiscLiabilities) + n(BS3M['MinorityInterest']) + n(BS3M['PreferredStockOfSubsidiary']) + n(BS3M['PreferredSecuritiesOutsideStockEquity']) + n(BS3M['PreferredStockEquity']) - n(BS3M['NonCurrentDeferredLiabilities']) - n(BS3M['NonCurrentAccruedExpenses'])))

        //evOverEbitda = (((n(ER['BasicAverageShares'] / 1000000) * n(prices[priceDate])) + (n(BS3M['CurrentDebtAndCapitalLeaseObligation']) + n(BS3M['LongTermDebt']) + n(BS3M['LongTermCapitalLeaseObligation']) + n(BS3M['NonCurrentDeferredLiabilities']) + n(BS3M['NonCurrentAccruedExpenses']) +  n(BS3M['DerivativeProductLiabilities']) + n(BS3M['EmployeeBenefits']) + n(BS3M['LongTermProvisions']) + n(BS3M['RegulatoryLiabilities']) + n(BS3M['OtherNonCurrentLiabilities']) + n(nonCurrentMiscLiabilities) + n(BS3M['MinorityInterest']) + n(BS3M['PreferredStockOfSubsidiary']) + n(BS3M['PreferredSecuritiesOutsideStockEquity']) + n(BS3M['PreferredStockEquity']) - n(BS3M['NonCurrentDeferredLiabilities']) - n(BS3M['NonCurrentAccruedExpenses']))) / (ebitda))
        //evOverCashFlow =(((n(ER['BasicAverageShares'] / 1000000) * n(prices[priceDate])) + (n(BS3M['CurrentDebtAndCapitalLeaseObligation']) + n(BS3M['LongTermDebt']) + n(BS3M['LongTermCapitalLeaseObligation']) + n(BS3M['NonCurrentDeferredLiabilities']) + n(BS3M['NonCurrentAccruedExpenses']) +  n(BS3M['DerivativeProductLiabilities']) + n(BS3M['EmployeeBenefits']) + n(BS3M['LongTermProvisions']) + n(BS3M['RegulatoryLiabilities']) + n(BS3M['OtherNonCurrentLiabilities']) + n(nonCurrentMiscLiabilities) + n(BS3M['MinorityInterest']) + n(BS3M['PreferredStockOfSubsidiary']) + n(BS3M['PreferredSecuritiesOutsideStockEquity']) + n(BS3M['PreferredStockEquity']) - n(BS3M['NonCurrentDeferredLiabilities']) - n(BS3M['NonCurrentAccruedExpenses']))) / (cashFlowFromOps))

        finaldate = IS['AsOfDate'];
    }

    const last4CFShares = CFSharesArray.slice(-4);
    const last4CFSum = last4CFShares.reduce((a, b) => a + b, 0);

    const last4grossMarginExcl = grossMarginExclArray.slice(-4);
    const grossMarginExclSum = last4grossMarginExcl.reduce((a, b) => a + b, 0);

    const last4totalRevenue = totalRevenueArray.slice(-4);
    const totalRevenueSum = last4totalRevenue.reduce((a, b) => a + b, 0);

    const grossMarginPercent = (grossMarginExclSum / totalRevenueSum) * 100;
    const cashFlowMargin = (cashFlowSum / totalRevenueSum) * 100;

    const last4Ebitda = ebitdaArray.slice(-4);
    const ebitdaSum = last4Ebitda.reduce((a, b) => a + b, 0);

    const evOverEbitda = (ebitdaSum !== 0 ? (enterpriseValue / ebitdaSum) : 0);
    const evOverCashFlow = (cashFlowSum !== 0 ? (enterpriseValue / cashFlowSum) : 0);

    finalValues.push({
        date: finaldate,
        cfirr: isNaN(cfirr) ? 0 :Math.round(cfirr),
        cfirrIncl: isNaN(cfirrIncl) ? 0 : Math.round(cfirrIncl),
        cashFlow: cashFlowSum,
        cashFlowShare: last4CFSum,
        grossMargin: grossMarginExclSum,
        growthRate: grossInvestedCapitalGrw,
        growthRateIncl: grossInvestedCapitalGrwIncl,
        growthTrend: plowbackRatio,
        growthTrendIncl: plowbackRatioIncl,
        totalRevenue: totalRevenueSum,
        grossMarginPercent: grossMarginPercent,
        cashFlowPercent: cashFlowMargin,
        debtAndEquivalents: debtAndEquivalents,
        marketCap: marketCap,
        debtOverMarketCap: debtOverMarketCap,
        evOverEbitda: evOverEbitda,
        evOverCashFlow: evOverCashFlow
    });

    return finalValues;
}

const n = (val) => Number(val) || 0;

export async function fetchGraphData(capRD, includeOtherIncome, selectedTax) {
    const incomeStatement12M = await getTableData("Income Statement 12M");
    const balanceSheet12M = await getTableData("Balance Sheet 12M");
    const earningReports12M = await getTableData("Earnings Reports 12M");
    const ratesTable = await getTableData("Rates");
    const PVLongTerm = await getTableData("PVLongTerm");
    const companyDescription = await getTableData("Company Long Description");
    const QuarterlyPrices = await getTableData("QuarterlyPrice");
    const rates = ratesTable[0];
    const rawPrice = QuarterlyPrices[1];
    const closePrice = QuarterlyPrices[3];
    const description = companyDescription[0]['LongDescription'];

    const prices = fillLeadingZerosWithFirstValue(rawPrice);

  const data = [];
  const stockData = [];
  let j = 0;
  let aDepPrev = 0;
  let naCAPrev = 0;
  let CFPrev = [0, 0, 0];
  let CF2Prev = [0, 0, 0, 0];
  let numOfPeriods = 0;
  let sharesArray = [];
  let assetLifeArray = [];
  let depreciationArray = [];
  let annualAssetLifeArray = [];
  let annualCapitalExcl = [];
  let assetLifeArrayInclIntangible = [];
  let annualAssetLifeArrayIncl = [];
  let annualCapitalIncl = [];
  let netFixedCapitalArray = [];
  let InflAdjGrossFixedCapitalArray = [];
  let InflAdjNetFixedCapitalArray = [];
  let grossInvestedCapitalExclArray = [];
  let grossInvestedCapitalExclArray2 = [];
  let grossInvCapitalInclArray = [];
  let grossInvestedCapitalInclArray = [];
  let netInvestedCapitalArray = [];
  let inflationTableValue = 0;
  let salvageValueArray = [];
  let salvageValueArray2 = [];
  let cashFlowArray = [];
  let CFSharesArray = [];
  let interestExpenseArray = [];
  let plowbackNumerator = [];
  let plowbackDenominator = [];
  let plowbackDenominatorIncl = [];
  let closingPrice = Object.values(closePrice);
  let closingPriceDate = Object.keys(prices).filter(k => k !== "Date");

  //CFIRR Variables
  let annualCFIRR = 0;
  let annualCFIRRIncl = 0;
  let stockPrice = [];
  let dividends = 0;


    closingPrice.shift();
    closingPriceDate.shift();
    closingPriceDate.reverse();
    closingPrice.reverse();
    closingPrice = closingPrice.slice(-incomeStatement12M.length);

    for (let i = 0; i < incomeStatement12M.length; i++) {
        const IS = incomeStatement12M[i], BS = balanceSheet12M[i], ER = earningReports12M[i], closePrice = closingPrice[i];

        if (!IS || IS['AsOfDate'] === 0) continue;

        //let closingPrice = Object.values(closePrice)

        // Derived values
        naCAPrev = n(IS['ResearchAndDevelopment']) + naCAPrev;

        const grossMarginExcl = n(IS['TotalRevenue']) - n(IS['CostOfRevenue']);
        const generalAdmin = generalAndAdmin(IS, IS);
        const otherIncome = n(IS['OtherIncomeExpense']) - n(IS['SpecialIncomeCharges']) - n(IS['RestructuringAndMergernAcquisition']);

        const ebitda = 
            grossMarginExcl - 
            generalAdmin - 
            (capRD ? 0 : n(IS['ResearchAndDevelopment'])) +
            n(IS['EarningsFromEquityInterest']) +
            n(IS['ReconciledDepreciation']) +
            (includeOtherIncome ? otherIncome : 0);

        const ebit = 
            n(ebitda) -
            n(IS['ReconciledDepreciation']);

        const nonOperationIncome = 
            n(IS['InterestIncome']) + 
            n(IS['RestructuringAndMergernAcquisition']) + 
            n(IS['AcquiredInProcessRnDIncome']) + 
            n(IS['SpecialIncomeCharges']) + 
            (n(IS['OtherIncomeExpense']) - n(IS['SpecialIncomeCharges']) - n(IS['RestructuringAndMergernAcquisition']));

        const totalOtherIncome = 
            n(IS['NetIncomeDiscontinuousOperations']) + 
            n(IS['NetIncomeExtraordinary']) + 
            n(IS['CumulativeEffectOfAccountingChange']) + 
            n(IS['NetIncomeFromTaxLossCarryforward']) + 
            n(IS['OtherOperatingExpenses']);

        const otherNonCurrentAssets = 
            n(BS['TotalNonCurrentAssets']) - 
            (n(BS['NetPPE']) + n(BS['Goodwill']) + 
            n(BS['NonCurrentDeferredAssets']) + (n(BS['GoodwillAndOtherIntangibleAssets']) - n(BS['Goodwill'])) + 
            (n(BS['InvestmentsAndAdvances']) + n(BS['DeferredCosts']) + n(BS['NetLoan']) + n(BS['DefinedPensionBenefit']) + n(BS['FinancialAssets'])));

        const investmentsAndAdvances = 
            n(BS['InvestmentsAndAdvances']) + 
            n(BS['DeferredCosts']) + 
            n(BS['NetLoan']) + 
            n(BS['DefinedPensionBenefit']) + 
            n(BS['FinancialAssets']);

        const otherIntangibleAssets = n(BS['GoodwillAndOtherIntangibleAssets']) - n(BS['Goodwill']);

        const depreciation = n(accumulatedDepreciation(BS, IS, aDepPrev));

        const totalOtherFixedCapital = 
            n(BS['Goodwill']) + 
            (n(BS['GoodwillAndOtherIntangibleAssets']) - n(BS['Goodwill'])) + 
            n(BS['NonCurrentDeferredAssets']) + 
            n(BS['TotalNonCurrentAssets']) - 
            (n(BS['NetPPE']) + n(BS['Goodwill']) + n(BS['NonCurrentDeferredAssets']) + (n(BS['GoodwillAndOtherIntangibleAssets']) - n(BS['Goodwill'])) + (n(BS['InvestmentsAndAdvances']) + n(BS['DeferredCosts']) + n(BS['NetLoan']) + n(BS['DefinedPensionBenefit']) + n(BS['FinancialAssets']))) + 
            (n(BS['InvestmentsAndAdvances']) + n(BS['DeferredCosts']) + n(BS['NetLoan']) + n(BS['DefinedPensionBenefit']) + n(BS['FinancialAssets']));

        const userTax = getTaxRate(IS, selectedTax, IS, IS, includeOtherIncome, capRD); //numbers are slightly different 

        const totalCurrentAssets = 
            (n(BS['CurrentAssets']) - 
            ((Math.max(n(BS['AccountsReceivable']), n(BS['Receivables']))) + 
            n(BS['Inventory']) + n(BS['PrepaidAssets']) + 
            n(BS['CurrentDeferredTaxesAssets']) + n(BS['CashAndCashEquivalents']) + n(BS['RestrictedCash']) + n(BS['OtherShortTermInvestments']))) + 
            n(BS['CashAndCashEquivalents']) + 
            n(BS['RestrictedCash']) + 
            n(BS['OtherShortTermInvestments']) + 
            (Math.max(n(BS['AccountsReceivable']), n(BS['Receivables']))) + n(BS['Inventory']) + n(BS['PrepaidAssets']) + n(BS['CurrentDeferredTaxesAssets']);

        const totalCurrentLiabilities = 
            n(BS['AccountsPayable']) + 
            n(BS['DividendsPayable']) + 
            n(BS['CurrentNotesPayable']) + 
            n(BS['CurrentDebtAndCapitalLeaseObligation']) + 
            n(BS['CurrentAccruedExpenses']) + 
            n(BS['CurrentDeferredLiabilities']) + 
            n(BS['TotalTaxPayable']) + 
            n(BS['OtherCurrentLiabilities']) + 
            (n(BS['CurrentLiabilities']) - (n(BS['AccountsPayable']) + n(BS['DividendsPayable']) + n(BS['CurrentNotesPayable']) + n(BS['CurrentDebtAndCapitalLeaseObligation']) + n(BS['CurrentAccruedExpenses']) + n(BS['CurrentDeferredLiabilities']) + n(BS['TotalTaxPayable']) + n(BS['OtherCurrentLiabilities'])));

        const otherMiscLiabilities = 
            n(BS['CurrentLiabilities']) - 
            (n(BS['AccountsPayable']) + n(BS['DividendsPayable']) + n(BS['CurrentNotesPayable']) + n(BS['CurrentDebtAndCapitalLeaseObligation']) + n(BS['CurrentAccruedExpenses']) + n(BS['CurrentDeferredLiabilities']) + n(BS['TotalTaxPayable']) + n(BS['OtherCurrentLiabilities']));

        const nonCurrentMiscLiabilities = 
            n(BS['TotalNonCurrentLiabilitiesNetMinorityInterest']) - 
            (n(BS['LongTermDebt']) + n(BS['LongTermCapitalLeaseObligation']) + 
            n(BS['NonCurrentDeferredLiabilities']) + n(BS['NonCurrentAccruedExpenses']) + 
            n(BS['DerivativeProductLiabilities']) + n(BS['EmployeeBenefits']) + 
            n(BS['LongTermProvisions']) + n(BS['RegulatoryLiabilities']) + n(BS['OtherNonCurrentLiabilities']));

        const debtAndEquivalents = 
            (n(BS['CurrentDebtAndCapitalLeaseObligation']) + 
            n(BS['LongTermDebt']) + 
            n(BS['LongTermCapitalLeaseObligation']) + 
            n(BS['NonCurrentDeferredLiabilities']) + 
            n(BS['NonCurrentAccruedExpenses']) +  
            n(BS['DerivativeProductLiabilities']) +
            n(BS['EmployeeBenefits']) + 
            n(BS['LongTermProvisions']) + 
            n(BS['RegulatoryLiabilities']) + 
            n(BS['OtherNonCurrentLiabilities']) + 
            n(nonCurrentMiscLiabilities) + 
            n(BS['MinorityInterest']) + 
            n(BS['PreferredStockOfSubsidiary']) + 
            n(BS['PreferredSecuritiesOutsideStockEquity']) + 
            n(BS['PreferredStockEquity']) - n(BS['NonCurrentDeferredLiabilities']) - n(BS['NonCurrentAccruedExpenses']))            
            
        // --- Period counter ---
        if (numOfPeriods < 3) numOfPeriods++;

        // --- Net Income ---
        const specialItems =
            n(IS['RestructuringAndMergernAcquisition']) +
            n(IS['AcquiredInProcessRnDIncome']) +
            n(IS['SpecialIncomeCharges']);

        const otherIncomeAdj =
            n(IS['OtherIncomeExpense']) -
            n(IS['SpecialIncomeCharges']) -
            n(IS['RestructuringAndMergernAcquisition']);

        const netIncome =
        (
            n(ebitda) -
            n(IS['ReconciledDepreciation']) +
            n(IS['InterestIncome']) +
            specialItems +
            otherIncomeAdj -
            n(IS['InterestExpense']) -
            n(IS['EarningsFromEquityInterest']) -
            n(IS['TaxProvision'])
        ) +
            n(IS['NetIncomeDiscontinuousOperations']) +
            n(IS['NetIncomeExtraordinary']) +
            n(IS['CumulativeEffectOfAccountingChange']) +
            n(IS['NetIncomeFromTaxLossCarryforward']) +
            n(IS['OtherOperatingExpenses']) +
            n(IS['MinorityInterests']);

        // --- Cash Flow from Ops ---
        const cashFlowFromOps =
            n(netIncome) -
            n(nonOperationIncome) -
            n(totalOtherIncome) +
            0.72 * n(IS['InterestExpense']) +
            n(IS['MinorityInterests']) +
            n(IS['ReconciledDepreciation']) -
            (n(userTax) - n(IS['TaxProvision']));

        aDepPrev = depreciation;

        // --- Shares ---
        sharesArray.push(n(BS['OrdinarySharesNumber']));
        const sharesRatio = Average(sharesArray);

        if (sharesArray.length === 2) sharesArray.shift();

        const cashFlowShares = (n(cashFlowFromOps) / n(sharesRatio))

        // --- Asset Life ---
        const netPPE = n(BS['NetPPE']);
        const grossPPE = n(BS['GrossPPE']);
        const accumulatedDep = n(depreciation);

        const grossFixedAssets =
          Math.max((netPPE + accumulatedDep), grossPPE) +
          ((capRD ? naCAPrev : 0))

        assetLifeArray.push(
            grossFixedAssets +
            n(otherNonCurrentAssets) +
            n(investmentsAndAdvances) +
            n(BS['Inventory'])
        );

        assetLifeArrayInclIntangible.push(
            grossFixedAssets + 
            n(BS['Goodwill']) + 
            n(otherIntangibleAssets) + 
            (n(otherNonCurrentAssets) + 
            n(investmentsAndAdvances)) + 
            n(BS['Inventory'])
        );

        depreciationArray.push(n(IS['ReconciledDepreciation']));

        const assetLife = (Math.min(n(Average(assetLifeArray) / n(IS['ReconciledDepreciation'])), 30));
        const assetLifeIncl = (Math.min(n(Average(assetLifeArrayInclIntangible) / n(IS['ReconciledDepreciation'])), 30));

        annualAssetLifeArray.push(assetLife);
        annualAssetLifeArrayIncl.push(assetLifeIncl);

        const averageAssetLife = Math.round(Math.max(3, Average(annualAssetLifeArray)));
        const averageAssetLifeIncl = Math.round(Math.max(3, Average(annualAssetLifeArrayIncl)));
        

        if (annualAssetLifeArray.length === 3) annualAssetLifeArray.shift();
        if (annualAssetLifeArrayIncl.length === 3) annualAssetLifeArrayIncl.shift();


        // --- Inflation ---
        const yearIndex =
        Math.ceil(
            Math.min(30, averageAssetLife) *
            (1 - netPPE / (netPPE + accumulatedDep))
        ) * 365;

        const inflationAge = new Date(IS['AsOfDate']).getTime() - yearIndex * 86400 * 1000;
        const inflationDate = findClosestDate(new Date(IS['AsOfDate']).getTime(), rates);
        const inflationAgeDate = findClosestDate(new Date(inflationAge).getTime(), rates);
        
        const inflationTableAge = rates[inflationAgeDate];

        if (rates[IS['AsOfDate']] !== undefined) {
          inflationTableValue = n(rates[IS['AsOfDate']]);
        } else {
          inflationTableValue = rates[inflationDate];
        }

        // --- Price ---
        const rawPriceDate = new Date(IS['AsOfDate']);
        rawPriceDate.setDate(rawPriceDate.getDate() + 45);
        const priceDate = findClosestDate(new Date(rawPriceDate).getTime(), prices);


        // --- Growth Rate Values ---
        // Get net working liabilities
        const currentLiabilities = 
            n(BS['AccountsPayable']) +
            n(BS['DividendsPayable']) +
            n(BS['CurrentNotesPayable']) +
            n(BS['CurrentAccruedExpenses']) +
            n(BS['CurrentDeferredLiabilities']) +
            n(BS['TotalTaxPayable']) +
            n(BS['OtherCurrentLiabilities']) +
            n(otherMiscLiabilities);

        const inflAdjGrossFixedCapitalExcl = (n(totalOtherFixedCapital) - 
            n(BS['Goodwill']) - 
            (n(BS['GoodwillAndOtherIntangibleAssets']) - 
            n(BS['Goodwill'])) + 
            n(grossFixedAssets)) * 
            ((n(inflationTableValue)) / n(inflationTableAge));
            
        const grossInvestedCapitalExcl =
            (inflAdjGrossFixedCapitalExcl) +
            Math.max(n(totalCurrentAssets) - currentLiabilities, 0);

        netFixedCapitalArray.push(
            netPPE + n(BS['NonCurrentDeferredAssets']) + n(otherNonCurrentAssets) + n(investmentsAndAdvances)
        );

        InflAdjGrossFixedCapitalArray.push(
            (n(totalOtherFixedCapital) -
                n(BS['Goodwill']) -
                (n(BS['GoodwillAndOtherIntangibleAssets']) - n(BS['Goodwill']))) *
                (n(inflationTableValue) / n(rates[inflationDate]))
            );

        InflAdjNetFixedCapitalArray.push(
            (netPPE +
                n(BS['NonCurrentDeferredAssets']) +
                n(otherNonCurrentAssets) +
                n(investmentsAndAdvances)) *
                (n(inflationTableValue) / n(rates[inflationDate]))
            );

        grossInvestedCapitalExclArray.push(grossInvestedCapitalExcl);

        grossInvCapitalInclArray.push(
          (n(totalOtherFixedCapital) +
            grossFixedAssets) *
            (n(inflationTableValue) / n(inflationTableAge)) +
          Math.max(n(totalCurrentAssets) - currentLiabilities, 0)
        )

        netInvestedCapitalArray.push(
        (netPPE +
            n(BS['NonCurrentDeferredAssets']) +
            n(otherNonCurrentAssets) +
            n(investmentsAndAdvances)) *
            (n(inflationTableValue) / n(rates[inflationDate])) +
            (n(totalCurrentAssets) - currentLiabilities)
        );

        // Growth Rates
        // const netFixedCapitalGrw = growthRate(netFixedCapitalArray.at(-1), netFixedCapitalArray.at(-5));
        // const inflAdjGrossFixedCapitalGrw = growthRate(InflAdjGrossFixedCapitalArray.at(-1), InflAdjGrossFixedCapitalArray.at(-5));
        // const inflAdjNetFixedCapitalGrw = growthRate(InflAdjNetFixedCapitalArray.at(-1), InflAdjNetFixedCapitalArray.at(-5));
        const capitalGrowth = growthRate(grossInvestedCapitalExclArray.at(-1), grossInvestedCapitalExclArray.at(-2)).toLocaleString("en-US", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        const capitalGrothIncl = growthRate(grossInvCapitalInclArray.at(-1), grossInvCapitalInclArray.at(-2));
        // const netInvestedCapitalGrw = growthRate(netInvestedCapitalArray.at(-1), netInvestedCapitalArray.at(-5));

        // --- CFIRR ---
        cashFlowArray.push(userTax);

        const salvageValue = Math.max(
            0,
            n(totalCurrentAssets) -
            (n(totalCurrentLiabilities) - n(BS['CurrentDebtAndCapitalLeaseObligation']))
        );

        salvageValueArray.push(salvageValue);
        salvageValueArray2.push(salvageValue);

        const cashFlowSum = cashFlowArray.reduce((a, b) => a + b, 0);
        const salvageValueAvg = Average(salvageValueArray);

        const inflAdjGrossFixedCapitalIncl = (n(totalOtherFixedCapital) + n(grossFixedAssets)) * ((n(inflationTableValue)) / n(inflationTableAge));

        const grossInvestedCapitalIncl =
          (inflAdjGrossFixedCapitalIncl) +
          Math.max(n(totalCurrentAssets) - currentLiabilities, 0);

        // const grossInvestedCapitalIncl =
        //     (n(totalOtherFixedCapital) +
        //         Math.max(netPPE + accumulatedDep, grossPPE) +
        //         naCAPrev) *
        //         (n(inflationTableValue) / n(rates[inflationDate])) +
        //     Math.max(n(totalCurrentAssets) - currentLiabilities, 0);


        grossInvestedCapitalInclArray.push(grossInvestedCapitalIncl);
        grossInvestedCapitalExclArray2.push(grossInvestedCapitalExcl);
        annualCapitalIncl.push(grossInvestedCapitalIncl);
        annualCapitalExcl.push(grossInvestedCapitalExcl);

        const cashFlowFromOps2 =
          n(ebitda) - n(userTax) - 0.28 * n(IS['InterestExpense']);

        // --------- CFIRR -----------
        const avgSalvageValue = Average(salvageValueArray2);
        const pvExcl = Average(annualCapitalExcl) * -1;
        const pvIncl = Average(annualCapitalIncl) * -1;

        annualCFIRR = CFIRR(averageAssetLife, cashFlowFromOps2, pvExcl, avgSalvageValue, 0, 0.07) * 100;
        annualCFIRRIncl = CFIRR(averageAssetLifeIncl, cashFlowFromOps2, pvIncl, salvageValueAvg, 0, 0.07) * 100;

        if (cashFlowArray.length > 1) {
            annualCapitalExcl.shift();
            annualCapitalIncl.shift();
            salvageValueArray.shift();
            salvageValueArray2.shift();
            assetLifeArray.shift();
            assetLifeArrayInclIntangible.shift();
        }

        if (cashFlowArray.length === 4) {
          cashFlowArray.shift();
        }

        // --- Plowback ---
        plowbackNumerator.push(cashFlowFromOps);
        plowbackDenominator.push(grossInvestedCapitalExcl);
        plowbackDenominatorIncl.push(grossInvestedCapitalIncl);
        interestExpenseArray.push(0.72 * n(IS['InterestExpense']));

        // Rolling sums for plowback
        const cashflowPlowback = [1].map((i) => n(plowbackNumerator.at(-i))).reduce((a, b) => a + b, 0);
        const interestExpensePlowback = [1].map((i) => n(interestExpenseArray.at(-i))).reduce((a, b) => a + b, 0);

        let plowbackRatio = 0;
        let plowbackRatioIncl = 0;
        if (grossInvestedCapitalExclArray.length > 1) {
            plowbackRatio = ((plowbackNumerator.at(-1) - interestExpenseArray.at(-1)) / plowbackDenominator.at(-1)) * 100;
            plowbackRatioIncl = ((plowbackNumerator.at(-1) - interestExpenseArray.at(-1)) / plowbackDenominatorIncl.at(-1)) * 100;
        }        

        if (closingPrice[i - 1] === 0 || closingPrice[i - 1] === undefined) {
            dividends = (closingPrice[i]);
        } else {
            dividends = (dividends + n(ER['DividendPerShare'])) * (n(closingPrice[i]) / n(closingPrice[i - 1]));
        }

        // --- Revenue Growth ---
        const cashFlowMargin = cashFlowFromOps / n(IS['TotalRevenue']);
        const grossMargin = (n(IS['TotalRevenue']) - n(IS['CostOfRevenue'])) / n(IS['TotalRevenue']);

        const marketEquity = (n(ER['BasicAverageShares'] / 1000000) * n(prices[priceDate]));

        // --- Margin Percentages ---
        const grossMarginPercent = (n(IS['TotalRevenue']) === 0 ? 0 : (n(IS['TotalRevenue']) - n(IS['CostOfRevenue'])) / n(IS['TotalRevenue']) * 100).toFixed(2);
        const cashFlowPercent = (n(IS['TotalRevenue']) === 0 ? 0 : cashFlowFromOps / n(IS['TotalRevenue']) * 100).toFixed(2);

        const enterpriseValue = ((n(ER['BasicAverageShares'] / 1000000) * n(prices[priceDate])) + (n(BS['CurrentDebtAndCapitalLeaseObligation']) + n(BS['LongTermDebt']) + n(BS['LongTermCapitalLeaseObligation']) + n(BS['NonCurrentDeferredLiabilities']) + n(BS['NonCurrentAccruedExpenses']) +  n(BS['DerivativeProductLiabilities']) + n(BS['EmployeeBenefits']) + n(BS['LongTermProvisions']) + n(BS['RegulatoryLiabilities']) + n(BS['OtherNonCurrentLiabilities']) + n(nonCurrentMiscLiabilities) + n(BS['MinorityInterest']) + n(BS['PreferredStockOfSubsidiary']) + n(BS['PreferredSecuritiesOutsideStockEquity']) + n(BS['PreferredStockEquity']) - n(BS['NonCurrentDeferredLiabilities']) - n(BS['NonCurrentAccruedExpenses'])));

        data.push({
            date: IS['AsOfDate'],
            lastValue: false,
            description: description,
            cfirr: isNaN(annualCFIRR) ? 0 : Math.round(annualCFIRR),
            cfirrIncl: isNaN(annualCFIRRIncl) ? 0 : Math.round(annualCFIRRIncl),
            growth: Math.round(capitalGrowth),
            growthIncl: Math.round(capitalGrothIncl),
            growthTrend: isNaN(plowbackRatio) || plowbackDenominator.at(-1) === 0 ? 0 : Math.round(plowbackRatio),
            growthTrendIncl: isNaN(plowbackRatioIncl) || plowbackDenominator.at(-1) === 0 ? 0 : Math.round(plowbackRatioIncl),
            totalRevenue: Math.round(n(IS['TotalRevenue']) * 100) / 100,
            grossMargin: Math.round(n((IS['TotalRevenue']) - n(IS['CostOfRevenue'])) * 100) / 100,
            cashFlow: Math.round(cashFlowFromOps * 100) / 100,
            cashFlowShare: sharesRatio === 0 ? 0 : Math.round(cashFlowShares * 100) / 100,
            marketCap: Math.round(marketEquity * 100) / 100,
            debtAndEquivalents: debtAndEquivalents.toFixed(2),
            debtOverMarketCap: isNaN(n((debtAndEquivalents / marketEquity))) || marketEquity === 0 ? 0 : n((debtAndEquivalents / marketEquity).toFixed(2)),
            grossMarginPercent: n(grossMarginPercent),
            cashFlowPercent: n(cashFlowPercent),
            ebitda: ebitda,
            evOverEbitda: ebitda === 0 ? 0 : Math.round(((enterpriseValue) / (ebitda)) * 10) / 10,
            evOverCashFlow: cashFlowFromOps === 0 ? 0 : Math.round(((enterpriseValue) / (cashFlowFromOps)) * 10) / 10,

        });

    }

    const finalValues = await getCurrentCashFlowShare(capRD, includeOtherIncome, selectedTax)
       
    if(data[data.length-1].date === finalValues[0].date) data.pop()

    data.push({
        lastValue: true,
        date: finalValues[0].date,
        cfirr: Math.round(finalValues[0].cfirr),
        cfirrIncl: finalValues[0].cfirrIncl,
        cashFlow: Math.round(finalValues[0].cashFlow * 100) / 100,
        grossMargin: Math.round(finalValues[0].grossMargin * 100) / 100,
        cashFlowShare: Math.round(finalValues[0].cashFlowShare * 100) / 100,
        growth: Math.round(finalValues[0].growthRate),
        growthIncl: Math.round(finalValues[0].growthRateIncl),
        growthTrend: Math.round(finalValues[0].growthTrend),
        growthTrendIncl: Math.round(finalValues[0].growthRateIncl),
        totalRevenue: Math.round(finalValues[0].totalRevenue * 100) / 100,
        grossMarginPercent: Math.round(finalValues[0].grossMarginPercent * 100) / 100,
        cashFlowPercent: Math.round(finalValues[0].cashFlowPercent * 100) / 100,
        debtAndEquivalents: Math.round(finalValues[0].debtAndEquivalents * 100) / 100,
        marketCap: Math.round(finalValues[0].marketCap * 100) / 100,
        debtOverMarketCap: n((finalValues[0].debtOverMarketCap).toFixed(2)),
        evOverEbitda: Math.round(finalValues[0].evOverEbitda * 10) / 10,
        evOverCashFlow: Math.round(finalValues[0].evOverCashFlow * 10) / 10
    });

    return data;
}

export async function fetchQuarterlyData(newcapRD, newincludeOtherIncome, newselectedTax) {

    const capRD = newcapRD;
    const includeOtherIncome = newincludeOtherIncome;
    const selectedTax = newselectedTax;

    const incomeStatement3M = await getTableData("Income Statement 3M");
    const balanceSheet3M = await getTableData("Balance Sheet 3M");
    const earningReports3M = await getTableData("Earnings Reports 3M");
    const incomeStatement12M = await getTableData("Income Statement 12M");
    const ratesTable = await getTableData("Rates");
    const adjustedIncomeStatements = getRowValue(incomeStatement3M, incomeStatement12M);
    const rates = ratesTable[0];

    const data = [];

    let numOfPeriods = 0;
    let aDepPrev = 0;
    let naCAPrev = 0;
    let inflationTableValue = 0;
    let cfirrTFQExcl = 0;
    let cfirrTFQIncl = 0;
    let assetLifeArray = [];
    let assetLifeArrayInclIntangible = []
    let depreciationArray = [];
    let cashFlowArray = [];
    let grossInvestedCapitalInclArray = [];
    let grossInvestedCapitalExclArray = [];
    let annualAssetLifeArray = [];
    let salvageValueArray = [];
    let plowbackNumerator = [];
    let plowbackDenominator = [];
    let plowbackDenominatorIncl = [];
    let interestExpenseArray = [];


    for (let i = 0; i < incomeStatement3M.length; i++) {
    const IS3M = incomeStatement3M[i], BS3M = balanceSheet3M[i], ER3M = earningReports3M[i], IS12M = incomeStatement12M[i];
    const IS = adjustedIncomeStatements[i];

    if (!IS3M || IS3M['AsOfDate'] === 0) continue;
    
        // --- Period counter ---
        if (numOfPeriods < 5) numOfPeriods++;

        naCAPrev = n(IS['ResearchAndDevelopment']) + naCAPrev;

        const ebitda = EBITDA(IS3M, IS12M, includeOtherIncome, capRD, IS)
        const otherIntangibleAssets = n(BS3M['GoodwillAndOtherIntangibleAssets']) - n(BS3M['Goodwill'])
        const otherNonCurrentAssets = n(BS3M['TotalNonCurrentAssets']) - (n(BS3M['NetPPE']) + n(BS3M['Goodwill']) + n(BS3M['NonCurrentDeferredAssets']) + (n(BS3M['GoodwillAndOtherIntangibleAssets']) - n(BS3M['Goodwill'])) + (n(BS3M['InvestmentsAndAdvances']) + n(BS3M['DeferredCosts']) + n(BS3M['NetLoan']) + n(BS3M['DefinedPensionBenefit']) + n(BS3M['FinancialAssets'])))
        const investmentsAndAdvances = n(BS3M['InvestmentsAndAdvances']) + n(BS3M['DeferredCosts']) + n(BS3M['NetLoan']) + n(BS3M['DefinedPensionBenefit']) + n(BS3M['FinancialAssets'])
        const userTax = getTaxRate(IS, selectedTax, IS3M, IS12M, includeOtherIncome, capRD)
        const totalOtherFixedCapital = n(BS3M['Goodwill']) + (n(BS3M['GoodwillAndOtherIntangibleAssets']) - n(BS3M['Goodwill'])) + n(BS3M['NonCurrentDeferredAssets']) + n(BS3M['TotalNonCurrentAssets']) - (n(BS3M['NetPPE']) + n(BS3M['Goodwill']) + n(BS3M['NonCurrentDeferredAssets']) + (n(BS3M['GoodwillAndOtherIntangibleAssets']) - n(BS3M['Goodwill'])) + (n(BS3M['InvestmentsAndAdvances']) + n(BS3M['DeferredCosts']) + n(BS3M['NetLoan']) + n(BS3M['DefinedPensionBenefit']) + n(BS3M['FinancialAssets']))) + (n(BS3M['InvestmentsAndAdvances']) + n(BS3M['DeferredCosts']) + n(BS3M['NetLoan']) + n(BS3M['DefinedPensionBenefit']) + n(BS3M['FinancialAssets']))
        const totalCurrentAssets = (n(BS3M['CurrentAssets']) - ((Math.max(n(BS3M['AccountsReceivable']), n(BS3M['Receivables']))) + n(BS3M['Inventory']) + n(BS3M['PrepaidAssets']) + n(BS3M['CurrentDeferredTaxesAssets']) + n(BS3M['CashAndCashEquivalents']) + n(BS3M['RestrictedCash']) + n(BS3M['OtherShortTermInvestments']))) + n(BS3M['CashAndCashEquivalents']) + n(BS3M['RestrictedCash']) + n(BS3M['OtherShortTermInvestments']) + (Math.max(n(BS3M['AccountsReceivable']), n(BS3M['Receivables']))) + n(BS3M['Inventory']) + n(BS3M['PrepaidAssets']) + n(BS3M['CurrentDeferredTaxesAssets'])
        const otherMiscLiabilities = n(BS3M['CurrentLiabilities']) - (n(BS3M['AccountsPayable']) + n(BS3M['DividendsPayable']) + n(BS3M['CurrentNotesPayable']) + n(BS3M['CurrentDebtAndCapitalLeaseObligation']) + n(BS3M['CurrentAccruedExpenses']) + n(BS3M['CurrentDeferredLiabilities']) + n(BS3M['TotalTaxPayable']) + n(BS3M['OtherCurrentLiabilities']))
        const totalCurrentLiabilities = n(BS3M['AccountsPayable']) + n(BS3M['DividendsPayable']) + n(BS3M['CurrentNotesPayable']) + n(BS3M['CurrentDebtAndCapitalLeaseObligation']) + n(BS3M['CurrentAccruedExpenses']) + n(BS3M['CurrentDeferredLiabilities']) + n(BS3M['TotalTaxPayable']) + n(BS3M['OtherCurrentLiabilities']) + (n(BS3M['CurrentLiabilities']) - (n(BS3M['AccountsPayable']) + n(BS3M['DividendsPayable']) + n(BS3M['CurrentNotesPayable']) + n(BS3M['CurrentDebtAndCapitalLeaseObligation']) + n(BS3M['CurrentAccruedExpenses']) + n(BS3M['CurrentDeferredLiabilities']) + n(BS3M['TotalTaxPayable']) + n(BS3M['OtherCurrentLiabilities'])))
        const nonOperationIncome = n(IS['InterestIncome']) + n(IS['RestructuringAndMergernAcquisition']) + n(IS['AcquiredInProcessRnDIncome']) + n(IS['SpecialIncomeCharges']) + (n(IS3M['OtherIncomeExpense']) - n(IS3M['SpecialIncomeCharges']) - n(IS3M['RestructuringAndMergernAcquisition']))
        const totalOtherIncome = n(IS['NetIncomeDiscontinuousOperations']) + n(IS['NetIncomeExtraordinary']) + n(IS['CumulativeEffectOfAccountingChange']) + n(IS['NetIncomeFromTaxLossCarryforward']) + n(IS['OtherOperatingExpenses'])

        const specialItems =
          n(IS['RestructuringAndMergernAcquisition']) +
          n(IS['AcquiredInProcessRnDIncome']) +
          n(IS['SpecialIncomeCharges']);

        const otherIncomeAdj =
          n(IS3M['OtherIncomeExpense']) -
          n(IS3M['SpecialIncomeCharges']) -
          n(IS3M['RestructuringAndMergernAcquisition']);

        const netIncome =
          (
            n(ebitda) -
            n(IS['ReconciledDepreciation']) +
            n(IS['InterestIncome']) +
            specialItems +
            otherIncomeAdj -
            n(IS['InterestExpense']) -
            n(IS['EarningsFromEquityInterest']) -
            n(IS['TaxProvision'])
          ) +
          n(IS['NetIncomeDiscontinuousOperations']) +
          n(IS['NetIncomeExtraordinary']) +
          n(IS['CumulativeEffectOfAccountingChange']) +
          n(IS['NetIncomeFromTaxLossCarryforward']) +
          n(IS['OtherOperatingExpenses']) +
          n(IS['MinorityInterests']);

        const netPPE = n(BS3M['NetPPE']);
        const grossPPE = n(BS3M['GrossPPE']);
        const accumulatedDep = n(accumulatedDepreciation(BS3M, IS3M, aDepPrev));

        aDepPrev = accumulatedDep;

        const grossFixedAssets =
          Math.max((netPPE + accumulatedDep), grossPPE) +
          ((capRD ? naCAPrev : 0))

        const cashFlowFromOps =
          n(netIncome) -
          n(nonOperationIncome) -
          n(totalOtherIncome) +
          0.72 * n(IS['InterestExpense']) +
          n(IS['MinorityInterests']) +
          n(IS['ReconciledDepreciation']) -
          (n(userTax) - n(IS['TaxProvision']));

        // --- Asset Life ---
        assetLifeArray.push(
            grossFixedAssets +
            n(otherNonCurrentAssets) +
            n(investmentsAndAdvances) +
            n(BS3M['Inventory'])
        );

        depreciationArray.push(n(IS['ReconciledDepreciation']));

        assetLifeArrayInclIntangible.push(
          grossFixedAssets +
            n(IS['ResearchAndDevelopment']) +
            n(BS3M['Goodwill']) +
            n(otherIntangibleAssets) +
            n(otherNonCurrentAssets) +
            n(investmentsAndAdvances) +
            n(BS3M['Inventory'])
        );

        const assetLife = Math.round(Math.min(Math.max(3, n(getAssetLife(numOfPeriods, IS, assetLifeArray, depreciationArray))), 30));
        const assetLifeInclIntangibles = Math.round(Math.min(Math.max(3, n(getAssetLife(numOfPeriods, IS, assetLifeArrayInclIntangible, depreciationArray))), 30));

        annualAssetLifeArray.push(assetLife);

        const averageAssetLife = (Math.max(3, Average(annualAssetLifeArray)));        

        // --- Inflation ---
        const yearIndex =
          Math.ceil(
            Math.min(30, averageAssetLife) *
              (1 - netPPE / (netPPE + accumulatedDep))
          ) * 365;

        const inflationAge = new Date(IS3M['AsOfDate']).getTime() - yearIndex * 86400 * 1000;
        const inflationDate = findClosestDate(new Date(IS3M['AsOfDate']).getTime(), rates);
        const inflationAgeDate = findClosestDate(new Date(inflationAge).getTime(), rates);

        const inflationTableAge = rates[inflationAgeDate];

        if (rates[IS3M['AsOfDate']] !== undefined) {
          inflationTableValue = n(rates[IS3M['AsOfDate']]);
        } else {
          inflationTableValue = rates[inflationAgeDate];
        }

        const currentLiabilities = 
          n(BS3M['AccountsPayable']) +
          n(BS3M['DividendsPayable']) +
          n(BS3M['CurrentNotesPayable']) +
          n(BS3M['CurrentAccruedExpenses']) +
          n(BS3M['CurrentDeferredLiabilities']) +
          n(BS3M['TotalTaxPayable']) +
          n(BS3M['OtherCurrentLiabilities']) +
          n(otherMiscLiabilities);

        const cashFlow = ebitda - userTax - (0.28 * n(IS['InterestExpense']))
        cashFlowArray.push(cashFlow)

        const salvageValue = Math.max(
          0,
          n(totalCurrentAssets) -
            (n(totalCurrentLiabilities) - n(BS3M['CurrentDebtAndCapitalLeaseObligation']))
        );

        const grossInvestedCapitalIncl =
          (n(totalOtherFixedCapital) +
            grossFixedAssets) *
            (n(inflationTableValue) / n(inflationTableAge)) +
          Math.max(n(totalCurrentAssets) - currentLiabilities, 0);

        const grossInvestedCapitalExcl =
          (n(totalOtherFixedCapital) -
            n(BS3M['Goodwill']) -
            (n(BS3M['GoodwillAndOtherIntangibleAssets']) - n(BS3M['Goodwill'])) +
            grossFixedAssets) *
            (n(inflationTableValue) / n(inflationTableAge)) +
          Math.max(n(totalCurrentAssets) - currentLiabilities, 0);

        grossInvestedCapitalInclArray.push(grossInvestedCapitalIncl)
        grossInvestedCapitalExclArray.push(grossInvestedCapitalExcl)

        salvageValueArray.push(salvageValue);

        const grossInvestedCapitalGrw = growthRate(grossInvestedCapitalExclArray.at(-1), grossInvestedCapitalExclArray.at(-5));
        const grossInvestedCapitalGrwIncl = growthRate(grossInvestedCapitalInclArray.at(-1), grossInvestedCapitalInclArray.at(-5));

        if (grossInvestedCapitalInclArray.length === 5) {
          const cashFlowSum = cashFlowArray.reduce((a, b) => a + b, 0);
          const salvageValueAvg = Average(salvageValueArray);
          const pvValueIncl = Average(grossInvestedCapitalInclArray) * -1;
          const pvValueExcl = Average(grossInvestedCapitalExclArray) * -1;

          cfirrTFQExcl = CFIRR(assetLife, cashFlowSum, pvValueExcl, salvageValueAvg, 0, 0.07);
          cfirrTFQIncl = CFIRR(assetLifeInclIntangibles, cashFlowSum, pvValueIncl, salvageValueAvg, 0, 0.07);

          salvageValueArray.shift();
          grossInvestedCapitalInclArray.shift();
          grossInvestedCapitalExclArray.shift();
        }

        if (cashFlowArray.length === 4) {
          cashFlowArray.shift();
          assetLifeArray.shift();
          assetLifeArrayInclIntangible.shift();
        }

        // --- Plowback ---
        plowbackNumerator.push(cashFlowFromOps);
        plowbackDenominator.push(grossInvestedCapitalExcl);
        plowbackDenominatorIncl.push(grossInvestedCapitalIncl);
        interestExpenseArray.push(0.72 * n(IS['InterestExpense']));

        // Rolling sums for plowback
        const cashflowPlowback = [5, 6, 7, 8].map((i) => n(plowbackNumerator.at(-i))).reduce((a, b) => a + b, 0);
        const interestExpensePlowback = [5, 6, 7, 8].map((i) => n(interestExpenseArray.at(-i))).reduce((a, b) => a + b, 0);

        const plowbackRatio =
          ((cashflowPlowback - interestExpensePlowback) / plowbackDenominator.at(-5)) * 100;

        const plowbackRatioIncl = 
            ((cashflowPlowback - interestExpensePlowback) / plowbackDenominatorIncl.at(-5)) * 100;

        data.push({
            date: IS3M['AsOfDate'],
            cfirr: Math.round(cfirrTFQExcl * 100),
            cfirrIncl: Math.round(cfirrTFQIncl * 100),
            growth: isNaN(grossInvestedCapitalGrw) || grossInvestedCapitalExclArray.at(-5) === 0 ? 0 : Math.round(grossInvestedCapitalGrw),
            growthIncl: isNaN(grossInvestedCapitalGrwIncl) || grossInvestedCapitalInclArray.at(-5) === 0 ? 0 : Math.round(grossInvestedCapitalGrwIncl),
            growthTrend: isNaN(plowbackRatio) || plowbackDenominator.at(-1) === 0 ? 0 : Math.round(plowbackRatio),
            growthTrendIncl: isNaN(plowbackRatioIncl) || plowbackDenominator.at(-5) === 0 ? 0 : Math.round(plowbackRatioIncl)
        })

    }

    return data
}

export async function fetchStockData() {
    const PVLongTerm = await getTableData("PVLongTerm");
    const PVTwoYears = await getTableData("PVTwoYears");
    const dividendData = await getTableData("Earnings Reports 3M");
    const QuarterlyPrice = await getTableData("QuarterlyPrice")

    let stockPrice = [];
    let stockPriceTY = [];
    let stockMonths = [];
    let stockMonthsTY = [];

    const rateObject = Object.values(QuarterlyPrice[3])
    const closePrice = PVLongTerm[3];
    const volumeData = PVLongTerm[4];

    const closePriceTY = PVTwoYears[3];
    const volumeDataTY = PVTwoYears[4];

    const rate = (rateObject[1])

    let closingPrice = Object.values(closePrice);
    let volume = Object.values(volumeData);

    let closingPriceTY = Object.values(closePriceTY);
    let volumeTY = Object.values(volumeDataTY)

    volume.shift(); 
    closingPrice.shift();
    closingPrice.reverse();

    volumeTY.shift(); 
    volumeTY.reverse();
    closingPriceTY.shift();
    closingPriceTY.reverse();

    let dates = Object.keys(closePrice).filter(k => k !== "Date");
    dates.shift();

    let datesTY = Object.keys(closePriceTY).filter(k => k !== "Date");
    datesTY.shift();

    const months = dates.map(dateStr => {
        const [year, month] = dateStr.split("-"); 
        return `${month}-${year}`; // "01-1981"
    }).reverse();

    dates.reverse();

    // const monthsTY = datesTY.map(dateStr => {
    //     const [year, month] = dateStr.split("-"); 
    //     return `${month}-${year}`; // "01-1981"
    // }).reverse();

    datesTY.reverse();
    // let trimDates = [];
    // if (closingPrice.length > 120) {
    //     volume = volume.slice(-121); // last 10 years
    //     trimDates = dates.slice(-121); // last 10 years
    //     stockPrice = closingPrice.slice(-121); // last 10 years
    // } else {
    //     stockPrice = closingPrice;
    // }
    stockMonths = months;
    stockMonthsTY = datesTY;

    const dividendMap = new Map();
    const dividendMapTY = new Map();
    for (const ER of dividendData) {
        if (!ER['AsOfDate'] || ER['AsOfDate'] === '0') continue;
        const [year, month] = ER['AsOfDate'].split("-");
        const key = `${month}-${year}`;
        dividendMap.set(key, ((n(ER['DividendPerShare']) * rate).toFixed(2)));
    
        const keyTY = ER['AsOfDate'];
        dividendMapTY.set(key, ((n(ER['DividendPerShare']) * rate).toFixed(2)))
    }

    let stockData = [];
    let dividendsPriceData = [];
    let stockDate = [];
    let stockDividends = [];
    let dividends = (closingPrice[0]); // Initial stock price
    let stockPriceInclDiv = [];

    let stockDataTY = [];
    let dividendsPriceDataTY = [];
    let stockDateTY = [];
    let stockDividendsTY = [];
    let dividendsTY = (closingPriceTY[0]); // Initial stock price
    let stockPriceInclDivTY = [];

    for (let i = 0; i < closingPrice.length; i++) {
        stockData.push({
            date: dates[i],
            stockPrice: n(closingPrice[i]).toFixed(2),
        });
    }

    for (let i = 0; i < closingPriceTY.length; i++) {
        stockDataTY.push({
            date: datesTY[i],
            stockPrice: n(closingPriceTY[i]).toFixed(2),
        });
    }

    const divArray = []
    for (let i = 0; i < closingPrice.length; i++) {
        const spDate = stockMonths[i]; // perfectly aligned now
        const [month, year] = spDate.split("-");
        const stockKey = `${month}-${year}`;
        const divPerShare = dividendMap.get(stockKey) || 0;

        stockDate.push(new Date(`${year}-${month}`));
        divArray.push(divPerShare);

        if (i > 0) {
            dividends =
                (n(dividends) + n(divPerShare)) *
                (n(closingPrice[i]) / n(closingPrice[i - 1]));

            stockPriceInclDiv.push((n(dividends)));
        } else {
            stockPriceInclDiv.push((n(dividends)));
        }

        // if (i > 121)  {

        //     trimDates = dates.slice(-121); // last 10 years
        //     stockPrice = closingPrice.slice(-121); // last 10 years
        //     stockDividends = stockPriceInclDiv.slice(-121); // last 10 years

        // // } else {
        // //     trimDates = dates; 
        // //     stockPrice = closingPrice; 
        // //     stockDividends = stockPriceInclDiv;
        // }

    }

    const divArrayTY = []
    for (let i = 0; i < closingPriceTY.length; i++) {
        const spDate = new Date(stockMonthsTY[i]);
        stockDateTY.push(spDate);
        let divPerShare = 0;

    // Build month-year key in the same format as dividendMapTY: "MM-YYYY"
    const monthStr = String(spDate.getMonth() + 1).padStart(2, "0");
    const yearMonthKey = `${monthStr}-${spDate.getFullYear()}`;

    // Only assign dividend if this is the last row of the month
    const isLastOfMonth =
        i === closingPriceTY.length - 1 || // last row overall
        new Date(stockMonthsTY[i + 1]).getMonth() !== spDate.getMonth();

        // Only assign dividend if the month exists in the dividend map
        if (isLastOfMonth && dividendMapTY.has(yearMonthKey)) {
            divPerShare = dividendMapTY.get(yearMonthKey);
        }

        divArrayTY.push(divPerShare);

        // Update price including dividend
        if (i > 0) {
            dividendsTY =
                (n(dividendsTY) + n(divPerShare)) *
                (n(closingPriceTY[i]) / n(closingPriceTY[i - 1]));

            stockPriceInclDivTY.push(n(dividendsTY));
        } else {
            stockPriceInclDivTY.push(n(dividendsTY));
        }
    }

    for (let i = 0; i < dates.length; i++) {
        dividendsPriceData.push({
            date: dates[i],
            ExcludingDividends: Math.round(n(closingPrice[i]) * 100) / 100,
            ReinvestedDividends: Math.round(n(stockPriceInclDiv[i]) * 100) / 100,
            volume: Math.round(n(volume[i]) * 100) / 100,
            dividends: divArray[i],
        });
    }

    for (let i = 0; i < datesTY.length; i++) {
        dividendsPriceDataTY.push({
            date: datesTY[i],
            ExcludingDividends: n(closingPriceTY[i]),
            ReinvestedDividends: Math.round(n(stockPriceInclDivTY[i]) * 100) / 100,
            volume: Math.round(n(volumeTY[i]) * 100) / 100,
            dividends: divArrayTY[i],
        });
    }
    
    return [dividendsPriceData, stockData, dividendsPriceDataTY];
}


export async function fetchDividendData(capRD, includeOtherIncome, selectedTax) {
    let tfqDividendsArray = [];
    let cashFlowPerShareArray = [];
    let tfqDividends = 0;
    let cashAvailable = 0;
    let payoutRatio = 0;
    const dividendData = await getTableData("Earnings Reports 3M");
    const QuarterlyPrices = await getTableData("QuarterlyPrice");
    const incomeStatement3M = await getTableData("Income Statement 3M");
    const prices = QuarterlyPrices[1];
    const exchangeRate = QuarterlyPrices[3];
    const data = [];

    for (let i = 0; i < incomeStatement3M.length; i++) {
        const ER = dividendData[i];
        const IS = incomeStatement3M[i]

        const netIncome =
        (
            n(n(IS['TotalRevenue']) - n(IS['CostOfRevenue']) - 
            generalAndAdmin(IS, IS) - 
            (capRD ? 0 : n(IS['ResearchAndDevelopment'])) +
            n(IS['EarningsFromEquityInterest']) +
            n(IS['ReconciledDepreciation']) +
            (includeOtherIncome ? n(IS['OtherIncomeExpense']) - n(IS['SpecialIncomeCharges']) - n(IS['RestructuringAndMergernAcquisition']) : 0)) -
            n(IS['ReconciledDepreciation']) +
            n(IS['InterestIncome']) +
            (n(IS['RestructuringAndMergernAcquisition']) +
            n(IS['AcquiredInProcessRnDIncome']) +
            n(IS['SpecialIncomeCharges'])) +
            (n(IS['OtherIncomeExpense']) -
            n(IS['SpecialIncomeCharges']) -
            n(IS['RestructuringAndMergernAcquisition'])) -
            n(IS['InterestExpense']) -
            n(IS['EarningsFromEquityInterest']) -
            n(IS['TaxProvision'])
        ) +
            n(IS['NetIncomeDiscontinuousOperations']) +
            n(IS['NetIncomeExtraordinary']) +
            n(IS['CumulativeEffectOfAccountingChange']) +
            n(IS['NetIncomeFromTaxLossCarryforward']) +
            n(IS['OtherOperatingExpenses']) +
            n(IS['MinorityInterests']);

        const nonOperationIncome = 
            n(IS['InterestIncome']) + 
            n(IS['RestructuringAndMergernAcquisition']) + 
            n(IS['AcquiredInProcessRnDIncome']) + 
            n(IS['SpecialIncomeCharges']) + 
            (n(IS['OtherIncomeExpense']) - n(IS['SpecialIncomeCharges']) - n(IS['RestructuringAndMergernAcquisition']));

        const totalOtherIncome = 
            n(IS['NetIncomeDiscontinuousOperations']) + 
            n(IS['NetIncomeExtraordinary']) + 
            n(IS['CumulativeEffectOfAccountingChange']) + 
            n(IS['NetIncomeFromTaxLossCarryforward']) + 
            n(IS['OtherOperatingExpenses']);

        const cashFlowFromOps =
          n(netIncome) -
          n(nonOperationIncome) -
          n(totalOtherIncome) +
          0.72 * n(IS['InterestExpense']) +
          n(IS['MinorityInterests']) +
          n(IS['ReconciledDepreciation']) -
          (n(getTaxRate(IS, false, IS, IS, false, capRD)) - n(IS['TaxProvision']));

        const cashFlowPerShare = (cashFlowFromOps - (0.72 * n(IS['InterestExpense']))) / n(ER['BasicAverageShares'] / 1000000);
        cashFlowPerShareArray.push(cashFlowPerShare);

        tfqDividendsArray.push(n(ER['DividendPerShare']));

        if (tfqDividendsArray.length === 4) {
            cashAvailable = cashFlowPerShareArray.reduce((a, b) => a + b, 0);
            tfqDividends = tfqDividendsArray.reduce((a, b) => a + b, 0);
            tfqDividendsArray.shift();
            cashFlowPerShareArray.shift();
            if (cashAvailable === 0) {
                payoutRatio = 0;
            } else {
                payoutRatio = (tfqDividends / cashAvailable) * 100;
          }
        }
    
        // --- Price ---
        const rawPriceDate = new Date(IS['AsOfDate']);
        rawPriceDate.setDate(rawPriceDate.getDate() + 45);
        const priceDate = findClosestDate(rawPriceDate, prices);

        const exchangeDate = findClosestDate(rawPriceDate, exchangeRate);

        const dividendYield = ((tfqDividends * n(exchangeRate[exchangeDate])) / n(prices[priceDate])) * 100;
      
          data.push({
              date: ER['AsOfDate'],
              dividendYield: isNaN(dividendYield) ? 0 : Math.round(dividendYield * 100) / 100,
              dividendPerShare: isNaN(n(ER['DividendPerShare'])) ? 0 : Math.round(n(ER['DividendPerShare']) * 100) / 100,
              cashAvailable: isNaN(cashAvailable) ? 0 : Math.round(cashAvailable * 100) / 100,
              tfqDividends: isNaN(tfqDividends) ? 0 : Math.round(tfqDividends * 100) / 100,
              payoutRatio: isNaN(payoutRatio) ? 0 : Math.round(payoutRatio * 100) / 100,
          });
      }
      return data;
  }
